import { mnemoService, proxyApiMnemo } from ".";

export const contactService = {
  listSubjects(dbYear) {
    const payload = mnemoService.buildPayload("getSubjects", "dbYear", dbYear);
    return proxyApiMnemo.get("contact/?payload=" + encodeURI(payload));
  },
  listDatesNoWorking(dbYear) {
    const payload = mnemoService.buildPayload("getDatesNoWorking", "dbYear", dbYear);
    return proxyApiMnemo.get("contact/?payload=" + encodeURI(payload));
  },
  listHours(dbYear, date) {
    const payload = mnemoService.buildPayloadObject("getHours", { dbYear, date });
    return proxyApiMnemo.get("contact/?payload=" + encodeURI(payload));
  },
  insertRequest(data) {
    const payload = mnemoService.buildPayloadObject("insertRequest", data);
    return proxyApiMnemo.post("contact/?payload=" + encodeURI(payload));
  },
};
